import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getCollectionStatus } from '../utils/collectionStatus';
import { API_BASE } from '../config';
import './TopNav.css';

export function TopNav() {
  const { user, token, authFetch } = useAuth();
  const [reviewCount, setReviewCount] = useState<number>(() => {
    const stored = localStorage.getItem('ws_review_count');
    return stored ? parseInt(stored, 10) : 0;
  });

  useEffect(() => {
    if (!token) return;
    authFetch(`${API_BASE}/v1/reviews/mine`)
      .then((res) => res.ok ? res.json() : null)
      .then((json) => {
        if (json?.data) {
          const count = Array.isArray(json.data) ? json.data.length : 0;
          setReviewCount(count);
          localStorage.setItem('ws_review_count', String(count));
        }
      })
      .catch(() => {});
  }, [token, authFetch]);

  const status = getCollectionStatus(reviewCount);

  return (
    <header className="top-nav">
      <div className="top-nav__inner container">
        <Link to="/" className="top-nav__logo" aria-label="Hygh Vybe home">
          <img
            src="/images/hyghvybe-logo-horiz.png"
            alt="Hygh Vybe"
            className="top-nav__logo-img"
          />
        </Link>

        <nav className="top-nav__actions">
          <Link to="/stash" className="top-nav__profile-link" aria-label="My Stash">
            {user?.pictureUrl ? (
              <img
                src={user.pictureUrl}
                alt={user.displayName || 'My Stash'}
                className="top-nav__avatar"
                referrerPolicy="no-referrer"
              />
            ) : (
              <svg
                className="top-nav__icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="8" r="4" />
                <path d="M4 20c0-4 4-7 8-7s8 3 8 7" />
              </svg>
            )}
            <span className="top-nav__stash-label">
              My Stash
              {user && status.tier !== 'none' && (
                <span className="top-nav__status-badge">{status.icon}</span>
              )}
            </span>
          </Link>
        </nav>
      </div>
    </header>
  );
}
